
import Vue from 'vue'
import App from './App'
import router from './router'
import 'lib-flexible/flexible'
import '@/static/js/flexible.js'
import http from './api/ajax.js' //ajax请求
import tools from './api/tools.js' //工具
import regulars from './api/regulars.js' //工具
import notice from './api/notice.js' //弹窗
import config from './api/common.js' //公共变量
import title from 'vue-wechat-title' //标题更新
import filter from './api/filter.js' //公共过滤器
import VueLazyload from 'vue-lazyload' //图片懒加载
import weixin from './api/weixin' //微信方法
import Vant from 'vant' // vant-ui
import { Lazyload } from 'vant';
import app from './api/app' //原生方法
import 'vant/lib/index.css'
import '@vant/touch-emulator';
import './sass/base/layer.scss';
import './sass/base/_common.scss';
import './sass/base/_reset.scss';
import store from './store/index';
import VConsole from 'vconsole';
import 'video.js/dist/video-js.css'// 视频播放器
import videojs from 'video.js';
window.videojs = videojs;
import 'videojs-contrib-hls';
// 低版本兼容
import ResizeObserver from 'resize-observer-polyfill'
window.ResizeObserver = ResizeObserver

if((location.href.includes('debug=1') || config.env == 0) && !location.href.includes('hideDebug=1')) {
  let vConsole = new VConsole();
  Vue.use(vConsole)
}
// 公用微信授权处理函数
weixin.forceAuth(() =>{
  initVue()
})
async function initVue() {
  tools.setOrgId();//保存orgId
  await tools.getAppLoginInfo() //获取app登录信息
  await tools.setRefreshToken();//如果不是app环境，刷新token
  Vue.use(http)
  Vue.use(tools)
  Vue.use(regulars)
  Vue.use(notice)
  Vue.use(filter)
  Vue.use(title)
  Vue.use(config)
  Vue.use(weixin)
  Vue.use(Vant)
  Vue.use(Lazyload)
  Vue.use(app)
  Object.keys(filter).forEach(key => {
    Vue.filter(key, filter[key])
  })
  Vue.directive('title', {
    inserted: function (el, binding) {
      tools.setWebTitle(binding.value);
    },
    update: function (el, binding) {
      tools.setWebTitle(binding.value);
    }
  });
  // 将API方法绑定到全局
  Vue.prototype.$http = http;
  Vue.prototype.$tools = tools;
  Vue.prototype.$regulars = regulars;
  Vue.prototype.$notice = notice;
  Vue.prototype.$store = store;
  Vue.prototype.$config = config;
  Vue.prototype.$weixin = weixin;
  Vue.prototype.$app = app;
  Vue.config.ignoredElements.push('wx-open-launch-weapp');
  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
}
